import { markerCodec, prefCodec, UI_PREFS, withCodec, writePref } from '@/lib/ui-prefs';

/**
 * The sign-in flow's markers in this tab's sessionStorage (SESSION_AUTH_KEYS), as prefs. A module of
 * their own so the auth store can use them too (it can't import lib/auth-redirect.ts, which imports
 * the store). `clearSessionAuthMarkers` in @shared/constants removes the same keys.
 */

/** A sign-in is under way (set before leaving for Google). */
export const AUTH_IN_PROGRESS = withCodec(UI_PREFS.authInProgress, markerCodec);

/** This tab left for Google mid sign-in; survives the round trip. */
export const OAUTH_DEPARTED_ORIGIN = withCodec(UI_PREFS.authOAuthDeparted, markerCodec);

/** Where to go after signing in. */
export const AUTH_REDIRECT = withCodec(UI_PREFS.authRedirect, prefCodec.text);

/**
 * Ends the sign-in round trip in this tab (the frontend's `clearSessionAuthMarkers`, through the
 * prefs so a marker held in memory goes too).
 */
export function clearAuthMarkers(): void {
  writePref(AUTH_IN_PROGRESS, false);
  writePref(OAUTH_DEPARTED_ORIGIN, false);
}
